import { render, staticRenderFns } from "./TransitionCollapseHeight.vue?vue&type=template&id=9c767d74"
import script from "./TransitionCollapseHeight.vue?vue&type=script&lang=js"
export * from "./TransitionCollapseHeight.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports